module.exports = __webpack_public_path__ + "img/pen-fancy-slash.482020c1.svg";